// extracted by mini-css-extract-plugin
module.exports = {"container":"Tab__container___23bvI","active":"Tab__active___2kH2O","badge":"Tab__badge___33Ids","gray-badge":"Tab__gray-badge___58DqR"};